import { useContext } from "react";
import { DragContext } from "../providers";

const useDrag = () => {
  const dragContext = useContext(DragContext);

  if (!dragContext) {
    throw new Error("useDrag must be used within a DragProvider");
  }

  return dragContext;
};

export default useDrag;
